import { render, staticRenderFns } from "./EditMyAccountIframe.vue?vue&type=template&id=20e3e335&"
import script from "./EditMyAccountIframe.vue?vue&type=script&lang=ts&"
export * from "./EditMyAccountIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports